export type TTestimonial = {
  id: string;
  text: string;
  name: string;
};

export const TestimonialsContent: TTestimonial[] = [
  {
    id: 'julia-s',
    text: 'Guter Schlaf garantiert! Die neuesten Ergebnisse der Schlafforschung werden hervorragend erklärt und sind enorm hilfreich, weil man das Thema endlich entspannt angehen kann.',
    name: 'Julia S.',
  },
  {
    id: 'sabine-g',
    text: 'Gamechanger! Ich habe die App als Gesundheitsmaßnahme meiner Krankenkasse genutzt. Innerhalb kurzer Zeit waren meine Schlafstörungen behoben. Klare Empfehlung!',
    name: 'Sabine G.',
  },
  {
    id: 'maria-w',
    text: 'Die App war für mich eine sehr gute Unterstützung. Dr. A. Vorster sprach mir aus der Seele. Das Wissen rund um den Schlaf hat mich weiter-gebracht, sodass ich nach dem Kurs bereits deutlich besser schlafen kann. Vielen Dank!',
    name: 'Maria W.',
  },
  {
    id: 'darius-b',
    text: 'Coole App! Räumt auf mit den Mythen rund um den Schlaf, was wir alles machen sollten… klärt auf, lässt einen reflektieren und bringt uns in ein entspanntes Verhältnis zum Thema Schlaf!',
    name: 'Darius B.',
  },
  {
    id: 'tine-h',
    text: 'Die App ist in allen ihren Teilen absolut empfehlenswert! Ich habe viel über gesunden Schlaf gelernt und schätze ihn jetzt viel hochwertiger ein! Die angebotenen Kurse und die Meditationen zum Einschlafen bzw. Entspannen gefallen mir sehr gut!',
    name: 'Tine H.',
  },
  {
    id: 'manfred-w',
    text: 'Über das Schlaflogbuch habe ich erstmals festgestellt, mit wie wenig Schlaf mein Körper &amp; meine Psyche auskommen müssen! Mein Schlafverhalten wieder zu korrigieren, hat mir so einiges an Energie zurück gebracht!! Dankeschön an die Entwickler!!',
    name: 'Manfred W.',
  },
];
